
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import SaveNotice from '../partials/save-notice.vue';

  import { seenSaveDialog, photo1Questions } from '../stores/activity-1.js';

  import Numbers from '../components/numbers.vue';

  import TextArea from '../components/text-area.vue';

  const ready = ref( false );

  onMounted( () => {

    watch( seenSaveDialog, () => {

      if ( seenSaveDialog.value ) setTimeout( () => ready.value = true, 100 );

    }, { immediate: true } );

  } );

</script>

<template>

  <article>

    <div class="grid lg:grid-cols-2 min-h-view gap-12 p-6 md:p-12 lg:p-24">

      <div :class="[ 'self-center justify-self-center max-w-xl transition-[opacity,transform] duration-1000', { 'opacity-0 -translate-x-full': ! ready } ]">

        <div class="uppercase text-neutral-600 font-bold">Activity 1: Hearing All the Stories</div>

        <div class="flex items-center gap-2 mt-2">
          
          <span class="uppercase text-neutral-600 font-bold">Photo</span>

          <Numbers :current="1" :total="4" />

        </div>

        <h2 class="mt-6 pb-6 text-4xl md:text-5xl font-heading uppercase border-b-[3px] border-black">Segregation Signage</h2>

        <p class="mt-8 leading-7 text-neutral-700">

          Soon after the 13th Amendment was ratified abolishing slavery

          in the United States, states and localities across the nation began

          to enact laws designed to restrict the rights of Black Americans.

        </p>

        <p class="mt-4 leading-7 text-neutral-700">

          Study the photo and react to the discussion prompts below.

        </p>

        <figure class="lg:hidden mt-12">

          <img class="w-full" src="../images/activity-1-photo-1.jpg" alt="Two historic signs that read: Elk Wallow Picnic Grounds for White Only, and, Lewis Mountain Picnic Grounds for Negroes." />

          <figcaption class="inline-flex p-6 italic text-sm font-bold bg-amber-300 shadow-md -translate-x-4 -translate-y-4">
            
            Signage in Shenandoah National Park
          
          </figcaption>

        </figure>

        <div v-for="( { id, question, answer }, index ) in photo1Questions" :key="id" class="max-w-xl mt-12">
          
          <label class="font-bold" :for="id">{{ index + 1 }}. {{ question }}</label>
        
          <TextArea :id="id" v-model="answer.value" v-slot="{ count, maxLength }">
            
            <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
          
          </TextArea>

        </div>

        <SaveNotice class="mt-12" />

        <div class="flex flex-wrap justify-between gap-6 max-w-xl mt-12">

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
              hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"

            to="/activity/1/intro">
            
            <ArrowLeftCircleIcon class="w-8" />

            <span>Back</span>
          
          </RouterLink>

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/1/photo/2">
            
            <span>Next</span>

            <ArrowRightCircleIcon class="w-8" />
          
          </RouterLink>

        </div>

      </div>

      <div :class="[ 'hidden lg:block transition-[opacity,transform] duration-700', { 'opacity-0 translate-x-full': ! ready } ]">

        <figure class="sticky top-40">

          <img class="w-full" src="../images/activity-1-photo-1.jpg" alt="Two historic signs that read: Elk Wallow Picnic Grounds for White Only, and, Lewis Mountain Picnic Grounds for Negroes." />

          <figcaption class="inline-flex p-6 italic text-sm font-bold bg-amber-300 shadow-md -translate-x-4 -translate-y-4">
            
            Signage in Shenandoah National Park during segregation.
          
          </figcaption>

        </figure>

      </div>

    </div>

  </article>

</template>
